import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { TradeHeader } from "../../molecules/SubHeader";
import { CreateOrderModal } from "./CreateOrderModal";
import { useGetOrdersForCompany } from "@/services/Orders";
import { useTradeLock } from "@/hooks/useTradeLock";
import MarketList from "./MarketLists";
import ActiveOrders from "./ActiveOrders";

const Market = () => {
  const { currentCompany, user } = useAuth();
  const navigate = useNavigate();

  const [isCreateOrderOpen, setIsCreateOrderOpen] = useState<boolean>(false);
  const { guardTradeLock } = useTradeLock();
  const openCreateOrder = guardTradeLock(() => setIsCreateOrderOpen(true));
  const [activeOrderPageNumber, setActiveOrderPageNumber] = useState(1);
  const [activeOrderLimit, setActiveOrderLimit] = useState(15);

  const { data: ordersData, isLoading: isLoadingOrderData } = useGetOrdersForCompany({
    companyId: currentCompany?.companyId as number,
    languageId: user?.language.id,
    includeInactive: false,
    pageNumber: activeOrderPageNumber,
    excludeContractOrders: true,
    limit: activeOrderLimit,
  });
  const orders = ordersData?.orders || [];
  const totalActiveOrders = ordersData?.totalHits ?? 0;

  return (
    <>
      <title>Reviver - Market</title>
      <meta name="description" content="Reviver - Market" />

      <TradeHeader createNew={openCreateOrder} orders={orders} companyName={currentCompany?.companyName ?? ""} />

      <CreateOrderModal isOpen={isCreateOrderOpen} onClose={() => setIsCreateOrderOpen(false)} onSubmit={(_) => {}} />

      <ActiveOrders
        createNew={openCreateOrder}
        handleActiveOrder={(order) => navigate(`/order/details/${order.id}`)}
        orders={orders}
        isLoadingOrders={isLoadingOrderData}
        pageNumber={activeOrderPageNumber}
        limit={activeOrderLimit}
        totalOrders={totalActiveOrders}
        onPageChange={setActiveOrderPageNumber}
        onRowsPerPageChange={(value) => {
          setActiveOrderLimit(value);
          setActiveOrderPageNumber(1);
        }}
      />

      <MarketList onCreateOrder={openCreateOrder} />
    </>
  );
};

export default Market;
